import type { IntakeFormField } from '../../api/bookingApi';
import type { V2Item } from './types';

const SELF_PAY_COVERAGE_KEYS = new Set([
  'insurance_company', 'group_number', 'local_number', 'policyholder',
  'policyholder_relationship', 'insured_name', 'insured_dob', 'insured_employer',
  'insurance_address', 'insurance_phone',
].flatMap((key) => [`${key}_primary`, `${key}_secondary`]));

/** Requiredness uses the whole item's answers, including fields on other screens. */
export function isFieldRequired(item: V2Item, field: IntakeFormField, wholeItemAnswers: Record<string, unknown>): boolean {
  if (!field.required) return false;
  if (field.field_type === 'signature' || field.field_type === 'initials' || field.field_type === 'file_upload') return true;
  return !(item.kind === 'intake'
    && item.insuranceStatusNoRelaxesRequired === true
    && wholeItemAnswers.insurance_status === 'No'
    && SELF_PAY_COVERAGE_KEYS.has(field.key));
}
